"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  node.addEventListener(event, handler, capture);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, capture);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/utils/addEventListener.js
// module id = 342
// module chunks = 70144966829960 114276838955818